<template>
  <div class="swiper-card card-outro">
    <!-- <h1>{{ title }}</h1> -->
    <!-- <Tracker class="tracker" :stats="stack.stats" :showComplete="false"/> -->
    <DashboardTrack v-if="isVisible" :readMore="true" :xp="stack.xp" @swiperUpdate="swiperUpdate" @readMore="readMore" />
    <!-- <div class="summary" v-if="showSummary">
      <transition-group name="fade-slide-bottom" tag="div">          
        <template v-for="step in summarySequence">
          <div
            v-if="step.type === 'tracker' && displayedSteps.includes(step.slug)"
            :key="step.slug"
            class="stat-tracker bounce-in"
          >
            <UserTrack :size="120" xprogress="progress" />
            <span class="message" v-html="$userEngine.getDialReckoner"></span>
          </div>

          <div
            v-if="step.type === 'border' && displayedSteps.includes(step.slug)"
            :key="`border-${step.slug}`"
            class="animated-border"
          ></div>

          <div
            v-else-if="step.type === 'stat' && displayedSteps.includes(step.slug)"
            :key="`stat-${step.slug}`"
            class="summary-item"
          >
            <transition-group name="fade-slide-right" tag="div" class="item-group">
              <div
                :key="`${step.slug}-icon`"
                :class="`${step.slug}-tone icon`"
                class="icon-text bounce-in"
              >
                <base-svg :svg="step.icon" height="20px" />
                <span>{{ getDiffLabel(step.slug) }}</span>
              </div>
              <span
                :key="`${step.slug}-more`"
                class="more bounce-in"
              >
                {{ getReckoner(step.slug) }}
              </span>
            </transition-group>
          </div>
        </template>
      </transition-group>
    </div>

    <Lottie ref="lottie" animation="confetti-jump" /> -->
  </div>
</template>

<script>
  // import Tracker from '@/components/v5/stacks/Tracker.vue';
  import DashboardTrack from '@/components/v5/elements/DashboardTrack.vue';
  // import UserTrack from '@/components/v5/elements/UserTrack.vue';
  // import Lottie from '@/components/v5/Lottie.vue';

  export default {
    data() {
      return {
        isVisible: false,
        // showSummary: false,
        // tracker: false,
        // displayedSteps: [],
      }
    },

    props: {
      slide: {
        type: Object
      },
      meta: {
        type: Object,
      },
      stack: {
        type: Object,
      },
    },

    computed: {
      title() {
        return `${this.meta.name}`;
      },
      diff() {
        return this.$userEngine.dialDiff;
      },
      // summaryItems() {
      //   return this.$userEngine.dialTracks;
      // },
      // summarySequence() {
      //   let aReturn = [];
      //   // this.summarySequence.unshift({ type: 'tracker', slug: 'tracker' });
      //   this.summaryItems.forEach((item) => {
      //     if (this.$userEngine.dialTrackDiffItem(item.slug)?.cx == 0) {
      //       return;
      //     }
      //     aReturn.push({ type: 'border', slug: `border-${item.slug}` });
      //     aReturn.push({ type: 'stat', ...item });
      //   });
      //   aReturn.push({ type: 'border', slug: `border-last` });
      //   return aReturn;
      // },
    },

    components: {
      // Tracker,
      DashboardTrack
      // UserTrack,
      // Lottie,
    },

    mounted() {
      this.$emit('enableNextAction');
    },

    methods: {
      swiperUpdate() {
        this.$emit('swiperUpdate');
      },

      readMore() {
        this.$emit('readMore');
      },

      // getLabel (slug) {
      //   return this.$userEngine.dialTrackLabel(slug);
      // },

      // getDiffLabel (slug) {
      //   return this.$userEngine.dialTrackDiffLabel(slug);
      // },

      // getReckoner (slug) {
      //   return this.$userEngine.dialTrackReckoner(slug);
      // },

      // animateSummary() {
      //   this.showSummary = true;
      //   this.displayedSteps = [];

      //   const promises = this.summarySequence.map((step, i) => {
      //     return new Promise((resolve) => {
      //       setTimeout(() => {
      //         this.displayedSteps.push(step.slug);
      //         this.$emit('swiperUpdate')
      //         // setTimeout(() => {
      //         //   this.progress[step.slug] = this.demo_progress[step.slug];
      //         // }, 300)
      //          this.EventBus.$emit("device:haptic", 'light');
      //         resolve();
      //       }, i * 600);
      //     });
      //   });

      //   if (!this.$refs.lottie) { return; }

      //   Promise.all(promises).then(() => {
      //     setTimeout(() => {
      //       this.EventBus.$emit("device:haptic", 'strong');
      //       this.$refs.lottie?.play();
      //     }, 900)
      //   });
      // },
    },
    
    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            this.isVisible = true;
          }
        },
        immediate: true,
      },

      'diff' () {
        if (!this.$userEngine.dialDiffReady) {
          return;
        }
        // setTimeout(() => {
        //   this.animateSummary();
        // }, 600)
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .tracker {
    align-self: center;
    margin-bottom: 1.1rem;
  }

  .more-btn {
    align-self: center;
    border-radius: 0;
    margin: 0.5rem 0 1.5rem 0;
    font-size: 0.9rem;
    font-weight: normal;
    background: transparent;
    padding: 0;
    padding-bottom: 3px;
    border-bottom: 1px solid rgba($neutral-400, 0.25);
    color: $neutral-400;

    &:hover {
      border-bottom: 1px solid $neutral-100;
      .darkmode & {
        border-bottom: 1px solid $neutral-600;
      }
    }
  }

  // .summary {
  //   width: 100%;
  //   margin-bottom: 4rem;

  //   .summary-item {
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     padding: 1rem 1.2rem;
  //     height: 60px;
  //     font-size: 16px;

  //     .more {
  //       color: $neutral-400;
  //     }

  //     .icon {
  //       display: flex;
  //       align-items: center;

  //       svg {
  //         margin-right: 0.5rem;
  //       }
  //     }

  //     .item-group {
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       width: 100%;
  //     }
  //   }

  //   .animated-border {
  //     height: 1px;
  //     width: 100%;
  //     background: rgba($neutral-400, 0.25);
  //     opacity: 0;
  //     transform: translateY(10px);
  //     animation: fade-slide-right 0.6s ease-in-out forwards;
  //   }
  // }

  // .stat-tracker {
  //   display: flex;
  //   align-items: center;
  //   margin-bottom: 1rem;
  //   animation: fade-slide-right 0.6s ease-in-out forwards;

  //   .message {
  //     font-size: 16px;
  //     margin-left: 1rem;
  //     text-align: left;
  //   }
  // }

  .action {
    button {
      background: $neutral-600;
      border: 1px solid rgba($neutral-400, 0.5);
      color: $neutral-100;

      .darkmode & {
        background: #0b0d0e;;
        border: 1px solid $neutral-300;
        color: $neutral-600;
      }
    }
  }


  // @keyframes fade-slide-right {
  //   from {
  //     opacity: 0;
  //     transform: translateX(50px);
  //   }
  //   to {
  //     opacity: 1;
  //     transform: translateX(0);
  //   }
  // }

  // @keyframes bounce-in {
  //   0% {
  //     transform: translateX(50px) scale(0.9);
  //     opacity: 0;
  //   }
  //   60% {
  //     transform: translateX(-5px) scale(1.05);
  //     opacity: 1;
  //   }
  //   100% {
  //     transform: translateX(0) scale(1);
  //   }
  // }

  // .fade-slide-right-enter-active {
  //   transition: all 0.6s ease-in-out;
  // }
  // .fade-slide-right-enter-from {
  //   transform: translateX(50px);
  //   opacity: 0;
  // }

  // .bounce-in {
  //   animation: bounce-in 0.6s ease-in-out both;
  //   animation-delay: 0.3s;
  // }
</style>